module.exports = __webpack_public_path__ + "static/media/ic_info-primary.f25a3c8a.svg";